export const ADD_REMINDER = 'ADD_REMINDER'
export const CLEAR_REMINDER = 'CLEAR_REMINDER'
export const DELETE_REMINDER = 'DELETE_REMINDER'
export const UPDATE_REMINDER = 'UPDATE_REMINDER'

